import React, { useEffect, useRef, useState } from 'react';
import { Button, Result, Spin } from 'antd';
import { useNavigate, useSearchParams } from 'react-router-dom';
import authService from '../utils/auth';

const OA_URL = 'https://oa.wanguotravel.com';

// 与 LoginPage 的落地规则一致
const homeOf = (role) => (['admin', 'operations', 'finance'].includes(role) ? '/' : '/sales');

/**
 * 从万国 OA 跳转进入：URL 带一次性票据 ?ticket=，换成登录态后按角色进入首页。
 * 票据只能用一次，StrictMode 下的二次执行用 ref 挡住。
 */
function SsoPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    const ticket = params.get('ticket');
    if (!ticket) {
      setError('登录链接无效，请从 OA 重新进入');
      return;
    }
    authService
      .ssoLogin(ticket)
      .then((data) => navigate(homeOf(data.user?.role), { replace: true }))
      .catch((err) => setError(err.message || '登录失败，请从 OA 重新进入'));
  }, [params, navigate]);

  if (!error) return <Spin size="large" tip="正在登录" fullscreen />;
  return (
    <Result
      status="warning"
      title="无法登录"
      subTitle={error}
      extra={[
        <Button type="primary" key="oa" href={OA_URL}>返回 OA</Button>,
        <Button key="login" onClick={() => navigate('/login', { replace: true })}>账号密码登录</Button>,
      ]}
    />
  );
}

export default SsoPage;
